module.exports = __webpack_public_path__ + "static/img/fb.431d947a.png";